<script>
import WorkerBalance from "@/views/Worker/Components/WorkerBalance.vue";

import {computed, onBeforeMount, onMounted, ref, watch} from "vue";
import useTools from "@/use/Tools.js";
import useSharedData from "@/use/SharedData.js";
import useValidation from "@/use/Validation.js";
import {useWorkerStore} from "@/stores/Worker/Worker";

import StrBankAutocomplete from "@/components/StrBankAutocomplete.vue";
import StrBankAgencyAutocomplete from "@/components/StrBankAgencyAutocomplete.vue";
import useSharedSelectData from "@/use/SharedSelectData";
import WCodeGeneration from "@/components/WCodeGeneration.vue";
import {useSecurityStore} from "@/stores/Security";
import PaySectionSelection from "@/components/PaySectionSelection.vue";
import WorkerImage from "@/views/Worker/Components/WorkerImage.vue";
import axios from "axios";
import useSharedMethod from "@/use/SharedMethod";

export default {
    components: {
        WorkerImage,
        PaySectionSelection,
        WCodeGeneration,
        StrBankAgencyAutocomplete,
        StrBankAutocomplete,
        WorkerBalance,
    },
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        viewAction: Boolean,
        deleteAction: Boolean,
    },
    setup(props) {
        const newOne = ref(false);
        const editOne = ref(false);
        
        const {$refs, $route, $router} = useTools();
        const {formatedDate, priceFormat, getDialogToolbar} = useSharedMethod();
        const {dialog, loading, overlay, inputColor, backgroundColor} = useSharedData();
        const {transferModes, sex, profiles, modesIrg, workerPhases} = useSharedSelectData();
        const {mxRules} = useValidation();
        
        
        const readonly = computed(() => props.viewAction || props.deleteAction);
        
        const workerStore = useWorkerStore();
        const securityStore = useSecurityStore();
        
        const rootPath = computed(() => `workers.${getDialogToolbar(props).action}`);
        
        const tab = ref(null);
        const backPath = ref('workers');
        const elevation = ref('elevation-0');
        const civilValidate = ref(true);
        const professionalValidate = ref(true);
        const allValidate = ref(true);
        
        const worker = ref({
            paySectionss: props.addAction ? [] : null,
            wifes: [],
            children: [],
            okCnas: false,
            okMutuelle: false,
            carteShifa: "0",
            maladieCronique: "0",
            outOfGrille: null,
            simulated: null,
            soumisPointage: "0",
            opensRight: false,
            rung: null,
            iep: null,
            modeIrg: null,
            profile: null,
            phase: "ACTIVE",
            head: false,
            setAsHead: false,
        });
        
        
        function getDefaultValues() {
            loading.value = true;
            axios.get(`/workers/defaultValues`).then(response => {
                let defaultValues = response.data;
                worker.value.iep = defaultValues.iep;
                worker.value.rung = defaultValues.rung;
                worker.value.modeIrg = defaultValues.modeIrg;
                worker.value.profile = defaultValues.profile;
                worker.value.simulated = defaultValues.simulated;
                worker.value.outOfGrille = defaultValues.outOfGrille;
                worker.value.stateId = defaultValues.stateId;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        const child = ref({
            birthDay: null,
            chronicDisease: "0",
            cnasRight: "0",
        });
        const childDialog = ref(false);
        const addChild = ref(false);
        
        function getBack() {
            $router.push({name: backPath.value});
        }
        
        function openChildDialog() {
            addChild.value = true;
            childDialog.value = true;
        }
        
        function openChildDialogForEdit(chd) {
            child.value = chd;
            childDialog.value = true;
        }
        
        function closeChildDialog() {
            childDialog.value = false;
            addChild.value = false;
            child.value = {
                birthDay: null,
                chronicDisease: "0",
                cnasRight: "0",
            }
        }
        
        function saveChild() {
            worker.value.children.push(child.value);
            closeChildDialog();
        }
        
        function isValid() {
            civilValidate.value = $refs.form1.validate();
            professionalValidate.value = $refs.form2.validate();
            allValidate.value = civilValidate.value && professionalValidate.value;
            return allValidate.value;
        }
        
        function findById(id) {
            loading.value = true;
            axios.get(`/workers/${id}`).then((response) => {
                worker.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function save() {
            if (isValid()) {
                loading.value = true;
                axios.post('/workers', worker.value).then(response => {
                    workerStore.addWorker(response.data);
                    saveImage(response.data.id);
                }).finally(() => {
                    loading.value = false;
                });
            }
        }
        
        function update() {
            if (isValid()) {
                loading.value = true;
                axios.put('/workers', worker.value).then(response => {
                    workerStore.updateWorker(response.data);
                    saveImage(response.data.id);
                }).finally(() => {
                    loading.value = false;
                });
            }
        }
        
        function remove() {
            loading.value = true;
            axios.delete(`/workers/${worker.value.id}`).then(() => {
                workerStore.deleteWorker(worker.value);
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }
        
        const importPaySectionsLoading = ref(false);
        
        function importPaySections() {
            importPaySectionsLoading.value = true;
            axios.put(`/workers/importPaySections/${worker.value.occupationId}`).then(response => {
                worker.value.paySectionss = response.data;
            }).finally(() => {
                importPaySectionsLoading.value = false;
            });
        }
        
        
        function editDuplicate(item) {
            newOne.value = false;
            editOne.value = true;
            findById(item.id);
        }
        
        const loadingResponsible = ref(false);
        
        function findResponsibleByOrganizationalChartId() {
            if (securityStore.authorities.READ_ORGANIZATIONAL_CHART && worker.value.organizationalChartId) {
                loadingResponsible.value = true;
                axios.get(`/organizationalCharts/findResponsible/${worker.value.organizationalChartId}`).then(response => {
                    worker.value.responsibleId = response.data;
                }).finally(() => {
                    loadingResponsible.value = false;
                })
            }
        }
        
        function updatePaySection(items) {
            worker.value.paySectionss = items;
        }
        
        onBeforeMount(() => {
            newOne.value = props.addAction;
            editOne.value = props.updateAction;
        });
        
        onMounted(() => {
            if ($route.params.backPath) {
                backPath.value = $route.params.backPath;
            }
            if (props.addAction) {
                getDefaultValues();
            } else {
                findById($route.params.id);
            }
        });
        
        const firstNameSelected = ref(false);
        const lastNameSelected = ref(false);
        
        const image = ref(null);
        
        function saveImage(id) {
            if (image.value) {
                loading.value = true;
                const formData = new FormData();
                formData.append("file", image.value);
                axios.post(`/workerImages/${id}`, formData).then(() => {
                    getBack();
                });
            } else {
                getBack();
            }
        }
        
        watch(() => worker.value, () => {
            workerStore.setWorker(worker.value)
        }, {immediate: true, deep: true});
        
        return {
            securityStore,
            image,
            firstNameSelected,
            lastNameSelected,
            newOne,
            editOne,
            modesIrg,
            workerPhases,
            transferModes,
            sex,
            profiles,
            mxRules,
            readonly,
            civilValidate,
            professionalValidate,
            allValidate,
            elevation,
            backPath,
            tab,
            dialog,
            loading,
            overlay,
            inputColor,
            backgroundColor,
            worker,
            child,
            childDialog,
            addChild,
            loadingResponsible,
            importPaySectionsLoading,
            rootPath,
            openChildDialog,
            openChildDialogForEdit,
            closeChildDialog,
            saveChild,
            save,
            update,
            remove,
            importPaySections,
            editDuplicate,
            findResponsibleByOrganizationalChartId,
            updatePaySection,
            getBack,
            formatedDate,
            priceFormat,
            getDialogToolbar,
        }
    },
};
</script>

<template>
    <div>
        <v-dialog
            transition="dialog-bottom-transition"
            v-model="dialog"
            persistent
            max-width="1500"
            scrollable
        >
            
            
            <v-card>
                <w-dialog-toolbar
                    :add-action="newOne"
                    :update-action="editOne"
                    :delete-action="deleteAction"
                    :view-action="viewAction"
                    :title="worker.name"
                />
                <w-overlay
                    :overlay="overlay"
                    :loading="loading"
                    :delete-action="deleteAction"
                    @remove="remove"
                    @cancel="overlay = false"
                />
                <v-card-text>
                    <v-tabs
                        class="tabs"
                        color="teal"
                        :background-color="backgroundColor"
                        vertical
                        slider-size="7"
                    >
                        <v-tab :class="elevation">
                            <v-icon left v-if="civilValidate">mdi-account</v-icon>
                            <v-icon left v-else color="red">mdi-alert</v-icon>
                            {{ $t('worker.info') }}
                        </v-tab>
                        <v-tab :class="elevation">
                            <v-icon left>mdi-family-tree</v-icon>
                            {{ $t('worker.wife_children') }}
                        </v-tab>
                        <v-tab :class="elevation">
                            <v-icon left v-if="professionalValidate">mdi-domain</v-icon>
                            <v-icon left v-else color="red">mdi-alert</v-icon>
                            {{ $t('worker.professional') }}
                        </v-tab>
                        <v-tab :class="elevation">
                            <v-icon left>mdi-bank</v-icon>
                            {{ $t('worker.bank') }}
                        </v-tab>
                        <v-tab :class="elevation">
                            <v-icon left>mdi-ev-station</v-icon>
                            {{ $t('worker.cnas_mutuelle') }}
                        </v-tab>
                        <v-tab :class="elevation" v-if="worker.paySlipReadOption">
                            <v-icon left>mdi-account-credit-card</v-icon>
                            {{ $t('common.pay') }}
                        </v-tab>
                        <v-tab :class="elevation" v-if="worker.paySlipReadOption">
                            <v-icon left>mdi-bookshelf</v-icon>
                            {{ $t('common.pay_sections') }}
                        </v-tab>
                        <v-tab :class="elevation">
                            <v-icon left>mdi-abjad-arabic</v-icon>
                            <strong>{{ $t('common.arabic') }}</strong>
                        </v-tab>
                        <v-tab :class="elevation">
                            <v-icon left>mdi-form-dropdown</v-icon>
                            {{ $t('worker.personal_field') }}
                        </v-tab>
                        <v-tab :class="elevation" v-if="worker.balanceReadOption">
                            <v-icon left>mdi-airplane</v-icon>
                            {{ $t('worker.vacation_and_balance') }}
                        </v-tab>
                        
                        <v-tab :class="elevation" v-if="worker.contratReadOption">
                            <v-icon left>mdi-relation-many-to-many</v-icon>
                            {{ $t('worker.contrats') }}
                        </v-tab>
                        <v-tab :class="elevation">
                            <v-icon left>mdi-sitemap</v-icon>
                            {{ $t('worker.workflow') }}
                        </v-tab>
                        <v-tab :class="elevation">
                            <v-icon left>mdi-history</v-icon>
                            {{ $t('worker.career') }}
                        </v-tab>
                        
                        <!-- Infos Civil -->
                        <v-tab-item eager>
                            <v-container fluid>
                                <v-form ref="form1" lazy-validation>
                                    <w-fieldset :title="$t('worker.civil')">
                                        <v-row>
                                            <v-col cols="4">
                                                <w-label :label="$t('worker.code')" required/>
                                                <w-code-generation
                                                    v-model="worker.code"
                                                    :entity="'WORKER'"
                                                    :load="newOne"
                                                    :readonly="viewAction || deleteAction"
                                                    :rules="[mxRules.required]"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('common.lastname')" required/>
                                                <w-text-field
                                                    v-model="worker.lastName"
                                                    :readonly="readonly"
                                                    :rules="[mxRules.required]"
                                                    @focus="lastNameSelected = true"
                                                    @blur="lastNameSelected = false"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('common.firstname')" required/>
                                                <w-text-field
                                                    v-model="worker.firstName"
                                                    :readonly="readonly"
                                                    :rules="[mxRules.required]"
                                                    @focus="firstNameSelected = true"
                                                    @blur="firstNameSelected = false"
                                                />
                                            </v-col>
                                            
                                            <v-col cols="4">
                                                <w-label :label="$t('worker.born')" required/>
                                                <w-date-picker
                                                    v-model="worker.birthDay"
                                                    birth-day-picker
                                                    :rules="[mxRules.required]"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label label="A" required/>
                                                <w-text-field
                                                    v-model="worker.birthPlace"
                                                    :readonly="readonly"
                                                    :rules="[mxRules.required]"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('worker.nationality')"/>
                                                <w-text-field
                                                    v-model="worker.nationalite"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            
                                            <v-col cols="4">
                                                <w-label :label="$t('common.sex')" required/>
                                                <w-enum-select
                                                    v-model="worker.sex"
                                                    :items="sex"
                                                    :rules="[mxRules.required]"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('data_select.WORKER_FAMILY_SITUATION')" required/>
                                                <w-data-select-autocomplete
                                                    v-model="worker.familySituationId"
                                                    type="WORKER_FAMILY_SITUATION"
                                                    :readonly="readonly"
                                                    :rules="[mxRules.required]"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('worker.wedding_date')"/>
                                                <w-date-picker
                                                    v-model="worker.weddingDate"
                                                    birth-day-picker
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                        </v-row>
                                    </w-fieldset>
                                    <br/>
                                    <w-fieldset :title="$t('worker.address_contact')">
                                        <v-row>
                                            <v-col cols="4">
                                                <w-label :label="$t('common.country_state')"/>
                                                <w-state-autocomplete
                                                    v-model="worker.addressCityStateId"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('common.country_city')"/>
                                                <w-city-autocomplete
                                                    v-model="worker.addressCityId"
                                                    :state-id="worker.addressCityStateId"
                                                    item-value="id"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('common.address')"/>
                                                <w-text-area
                                                    v-model="worker.address"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            
                                            <v-col cols="4">
                                                <w-label :label="$t('worker.personal_phone')"/>
                                                <w-text-field
                                                    v-model="worker.personalPhone"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('worker.professional_phone')"/>
                                                <w-text-field
                                                    v-model="worker.professionalPhone"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('common.email')"/>
                                                <w-text-field
                                                    v-model="worker.email"
                                                    :readonly="readonly"
                                                ></w-text-field>
                                            </v-col>
                                        </v-row>
                                    </w-fieldset>
                                    <br/>
                                    <w-fieldset :title="$t('common.observation')">
                                        <v-row dense>
                                            <v-col cols="8">
                                                <w-simple-text-area
                                                    v-model="worker.observation"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <WorkerImage
                                                    v-model="image"
                                                    :worker-id="worker.id"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                        </v-row>
                                    </w-fieldset>
                                </v-form>
                            </v-container>
                        </v-tab-item>
                        <!-- Enfants Et Conjoint(s) -->
                        <v-tab-item eager>
                            <v-container fluid>
                                <w-fieldset :title="$t('worker.ascending')">
                                    <v-row>
                                        <v-col cols="6">
                                            <w-label :label="$t('worker.father_first_name')"/>
                                            <w-text-field
                                                v-model="worker.prenomPere"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="6">
                                            <w-label :label="$t('common.birth_day')"/>
                                            <w-date-picker
                                                v-model="worker.dateNaissancePere"
                                                birth-day-picker
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.mother_last_name')"/>
                                            <w-text-field
                                                v-model="worker.nomMere"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.mother_first_name')"/>
                                            <w-text-field
                                                v-model="worker.prenomMere"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('common.birth_day')"/>
                                            <w-date-picker
                                                v-model="worker.dateNaissanceMere"
                                                birth-day-picker
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                                <br/>
                                <w-fieldset
                                    :title="$t('worker.spouses')"
                                    :show-add-action="!readonly && worker.wifes.length < 4"
                                    @add="worker.wifes.push({hasWork: '0', chronicDisease: '0'})"
                                >
                                    <v-row
                                        dense
                                        v-for="(wife, index) in worker.wifes"
                                        :key="index"
                                    >
                                        <v-col cols="3">
                                            <w-label :label="$t('common.lastname')"/>
                                            <w-text-field
                                                v-model="wife.lastName"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="2">
                                            <w-label :label="$t('common.firstname')"/>
                                            <w-text-field
                                                v-model="wife.firstName"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="2">
                                            <w-label :label="$t('common.birth_day')"/>
                                            <w-date-picker
                                                v-model="wife.birthDay"
                                                birth-day-picker
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="2">
                                            <w-label :label="$t('worker.wife_work')"/>
                                            <w-enum-select
                                                v-model="wife.hasWork"
                                                :items="[
                                                    {id: '1', name: $t('common.yes')},
                                                    {id: '0', name: $t('common.no')},
                                                ]"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="2">
                                            <w-label :label="$t('worker.chronic_disease')"/>
                                            <w-enum-select
                                                v-model="wife.chronicDisease"
                                                :items="[
                                                    {id: '1', name: $t('common.yes')},
                                                    {id: '0', name: $t('common.no')},
                                                ]"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="1">
                                            <w-btn-icon
                                                classe="mt-5"
                                                icon="mdi-trash-can"
                                                color="red"
                                                :disabled="readonly"
                                                @press="worker.wifes.splice(index, 1)"
                                            />
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                                <br/>
                                <w-fieldset
                                    :title="$t('worker.children')"
                                    :show-add-action="!readonly"
                                    @add="openChildDialog"
                                >
                                    <v-row dense>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.allocation_children_number')"/>
                                            <w-text-field
                                                v-model="worker.allocationChildrenNumber"
                                                type="number"
                                                min="0"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                    </v-row>
                                    <br/>
                                    <v-simple-table dense class="elevation-2">
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-left">{{ $t('common.lastname') }}</th>
                                                <th class="text-left">{{ $t('common.firstname') }}</th>
                                                <th class="text-left">{{ $t('common.sex') }}</th>
                                                <th class="text-left">{{ $t('common.birth_day') }}</th>
                                                <th class="text-left">{{ $t('worker.schooled') }}</th>
                                                <th class="text-left">{{ $t('worker.school_level') }}</th>
                                                <th class="text-left">{{ $t('worker.chronic_disease') }}</th>
                                                <th class="text-left">{{ $t('worker.cnas_law') }}</th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr
                                                v-for="(chd, index) in worker.children"
                                                :key="index"
                                            >
                                                <td>{{ chd.lastName }}</td>
                                                <td>{{ chd.firstName }}</td>
                                                <td>{{ chd.sex }}</td>
                                                <td>{{ formatedDate(chd.birthDay) }}</td>
                                                <td>{{ chd.schoolSituationName }}</td>
                                                <td>{{ chd.schoolLevel }}</td>
                                                <td>
                                                    <v-icon v-if="chd.chronicDisease === '1'" color="teal">
                                                        mdi-check-circle
                                                    </v-icon>
                                                    <v-icon v-if="chd.chronicDisease === '0'" color="red">
                                                        mdi-check-circle
                                                    </v-icon>
                                                </td>
                                                <td>
                                                    <v-icon v-if="chd.cnasRight === '1'" color="teal">
                                                        mdi-check-circle
                                                    </v-icon>
                                                    <v-icon v-if="chd.cnasRight === '0'" color="red">
                                                        mdi-check-circle
                                                    </v-icon>
                                                </td>
                                                <td>
                                                    <w-btn-icon
                                                        color="orange"
                                                        icon="mdi-pencil-box-multiple"
                                                        :disabled="readonly"
                                                        @press="openChildDialogForEdit(chd)"
                                                    />
                                                </td>
                                                <td>
                                                    <w-btn-icon
                                                        color="red"
                                                        icon="mdi-trash-can"
                                                        :disabled="readonly"
                                                        @press="worker.children.splice(index, 1)"
                                                    />
                                                </td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </w-fieldset>
                            </v-container>
                        </v-tab-item>
                        <!-- Professionel -->
                        <v-tab-item eager>
                            <v-container fluid>
                                <v-form ref="form2" lazy-validation>
                                    <w-fieldset :title="$t('worker.professional')">
                                        <v-row>
                                            <v-col cols="4">
                                                <w-label :label="$t('module.occupation')" required/>
                                                <str-occupation-autocomplete
                                                    v-model="worker.occupationId"
                                                    :readonly="readonly"
                                                    :rules="[mxRules.required]"
                                                    resource="occupations"
                                                />
                                            </v-col>
                                            
                                            <v-col cols="4">
                                                <w-label :label="$t('module.organizational_chart')" required/>
                                                <organizational-chart-field
                                                    v-model="worker.organizationalChartId"
                                                    :readonly="readonly"
                                                    @changed="findResponsibleByOrganizationalChartId"
                                                    :rules="[mxRules.required]"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <v-checkbox
                                                    v-if="readonly"
                                                    v-model="worker.head"
                                                    color="amber"
                                                    class="mt-6"
                                                    label="Responsable Unité Organisationnelle"
                                                    readonly
                                                    hide-details
                                                />
                                                <v-checkbox
                                                    v-else
                                                    v-model="worker.setAsHead"
                                                    color="amber"
                                                    class="mt-6"
                                                    label="Définir tête de l’unité organisationnelle"
                                                    hide-details
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('worker.responsible')" required/>
                                                <str-worker-autocomplete
                                                    v-model="worker.responsibleId"
                                                    :external-loading="loadingResponsible"
                                                    :readonly="readonly"
                                                    :rules="[mxRules.required]"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('worker.recruitment_date')" required/>
                                                <w-date-picker
                                                    v-model="worker.realEnterDate"
                                                    :rules="[mxRules.required]"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('data_select.WORKER_COMPANY')"/>
                                                <w-data-select-autocomplete
                                                    v-model="worker.companyId"
                                                    type="WORKER_COMPANY"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('data_select.WORKER_WORKPLACE')"/>
                                                <w-data-select-autocomplete
                                                    v-model="worker.workplaceId"
                                                    type="WORKER_WORKPLACE"
                                                    :readonly="readonly"
                                                />
                                            </v-col>
                                            
                                            <v-col cols="4">
                                                <w-label :label="$t('worker.status')" required/>
                                                <w-enum-select
                                                    v-model="worker.phase"
                                                    :items="workerPhases"
                                                    not-clearable
                                                    readonly
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('data_select.WORKER_STATE')" required/>
                                                <w-data-select-autocomplete
                                                    v-model="worker.stateId"
                                                    type="WORKER_STATE"
                                                    :readonly="readonly"
                                                    :rules="[mxRules.required]"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('common.exit_date')"/>
                                                <w-date-picker
                                                    v-model="worker.exitDate"
                                                    readonly
                                                    color="red"
                                                />
                                            </v-col>
                                            <v-col cols="4">
                                                <w-label :label="$t('data_select.WORKER_EXIT_REASON')"/>
                                                <w-data-select-autocomplete
                                                    v-model="worker.leavingCauseId"
                                                    readonly
                                                    color="red"
                                                    type="CONTRAT_EXIT_RATIONALE"
                                                />
                                            
                                            </v-col>
                                        </v-row>
                                    </w-fieldset>
                                </v-form>
                            </v-container>
                        </v-tab-item>
                        <!-- Banque -->
                        <v-tab-item eager>
                            <v-container fluid>
                                <w-fieldset :title="$t('worker.business_bank')">
                                    <v-row>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.bank')"/>
                                            <str-bank-autocomplete
                                                v-model="worker.companyAgencyBankId"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.agency')"/>
                                            <str-bank-agency-autocomplete
                                                v-model="worker.companyAgencyId"
                                                :bank-id="worker.companyAgencyBankId"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.transfer_mode')"/>
                                            <w-enum-select
                                                v-model="worker.transferMode"
                                                :items="transferModes"
                                            />
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                                <br/>
                                <w-fieldset :title="$t('module.worker')">
                                    <v-row>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.bank')"/>
                                            <str-bank-autocomplete
                                                v-model="worker.agencyBankId"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.agency')"/>
                                            <str-bank-agency-autocomplete
                                                v-model="worker.agencyId"
                                                :bank-id="worker.agencyBankId"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.bank_account_number')"/>
                                            <w-text-field
                                                v-model="worker.numCompte"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                                <br/>
                                <w-fieldset title="CCP">
                                    <v-row dense>
                                        <v-col cols="12">
                                            <w-text-field v-model="worker.numCcp" :readonly="readonly"/>
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                            </v-container>
                        </v-tab-item>
                        <!-- CNAS ET MUTUELLE -->
                        <v-tab-item eager>
                            <v-container fluid>
                                <w-fieldset :title="$t('pay_slip.cnas')">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-switch
                                                v-model="worker.okCnas"
                                                inset
                                                :readonly="readonly"
                                                color="blue darken-2"
                                                :label="$t('worker.ok_cnas')"
                                                hide-details
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.nss')"/>
                                            <w-text-field
                                                v-model="worker.nss"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('module.cnas_agency')"/>
                                            <str-cnas-agcency-autocomplete
                                                v-model="worker.cnasAgencyId"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.abattement')"/>
                                            <str-worker-def-autocomplete
                                                v-model="worker.abattementId"
                                                :readonly="readonly"
                                                resource="abattements"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('data_select.CNAS_TYPE_DECLARATION')"/>
                                            <w-data-select-autocomplete
                                                v-model="worker.declarationId"
                                                :readonly="readonly"
                                                :type="'CNAS_TYPE_DECLARATION'"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.date_right_open')"/>
                                            <w-date-picker
                                                v-model="worker.dateRightOpen"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                                <br/>
                                <w-fieldset :title="$t('pay_slip.mutual')">
                                    <v-row dense>
                                        <v-col cols="12">
                                            <v-switch
                                                v-model="worker.okMutuelle"
                                                inset
                                                :readonly="readonly"
                                                color="purple"
                                                :label="$t('worker.ok_mutuelle')"
                                                hide-details
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label=" $t('data_select.MUTUAL_COMPANY')"/>
                                            <w-data-select-autocomplete
                                                v-model="worker.mutualCompanyId"
                                                :readonly="readonly"
                                                type="MUTUAL_COMPANY"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.mutuelle_number')"/>
                                            <w-text-field
                                                v-model="worker.numMutuelle"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                                <br/>
                                <w-fieldset :title="$t('worker.shifa_card')">
                                    <v-row dense>
                                        <v-col cols="12">
                                            <v-switch
                                                v-model="worker.carteShifa"
                                                :true-value="'1'"
                                                :false-value="'0'"
                                                inset
                                                :readonly="readonly"
                                                color="teal"
                                                :label="$t('worker.shifa_card')"
                                                hide-details
                                            ></v-switch>
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.shifa_card_number')"/>
                                            <w-text-field
                                                v-model="worker.carteShifaNumber"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('data_select.WORKER_SICK_POSITION')"/>
                                            <w-data-select-autocomplete
                                                v-model="worker.sickPositionId"
                                                type="WORKER_SICK_POSITION"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                        
                                        <v-col cols="12">
                                            <v-switch
                                                v-model="worker.maladieCronique"
                                                :true-value="'1'"
                                                :false-value="'0'"
                                                inset
                                                :readonly="readonly"
                                                color="red"
                                                :label="$t('worker.chronic_disease')"
                                                hide-details
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.chronic_disease_description')"/>
                                            <w-text-area
                                                v-model="worker.maladieCroniqueDescription"
                                                :readonly="readonly"
                                                color="red"
                                            />
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                            </v-container>
                        </v-tab-item>
                        <!-- Paie -->
                        <v-tab-item eager v-if="worker.paySlipReadOption">
                            <v-container fluid>
                                <w-fieldset :title="$t('worker.param_calculate')">
                                    <v-row>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.mode_irg')"/>
                                            <w-enum-select
                                                v-model="worker.modeIrg"
                                                :items="modesIrg"
                                                :readonly="readonly || !worker.paySlipUpdateOption"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.profile')"/>
                                            <w-enum-select
                                                v-model="worker.profile"
                                                :items="profiles"
                                                :readonly="readonly || !worker.paySlipUpdateOption"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('worker.abattement')"/>
                                            <str-worker-def-autocomplete
                                                v-model="worker.abattementId"
                                                :resource="'abattements'"
                                                :readonly="readonly || !worker.paySlipUpdateOption"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('data_select.WORKER_CATEGORIZATION')"/>
                                            <w-data-select-autocomplete
                                                v-model="worker.categorizationId"
                                                type="WORKER_CATEGORIZATION"
                                                :readonly="readonly || !worker.paySlipUpdateOption"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('pay_slip.rung')"/>
                                            <w-text-field
                                                v-model="worker.rung"
                                                :readonly="readonly || !worker.paySlipUpdateOption"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label :label="$t('pay_slip.iep')"/>
                                            <w-text-field
                                                v-model="worker.iep"
                                                :readonly="readonly || !worker.paySlipUpdateOption"
                                            />
                                        </v-col>
                                        
                                        <v-col cols="4">
                                            <v-switch
                                                v-model="worker.outOfGrille"
                                                :color="'red'"
                                                inset
                                                :readonly="readonly || !worker.paySlipUpdateOption"
                                                :label="$t('worker.out_of_grille')"
                                                hide-details="auto"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <v-switch
                                                v-model="worker.simulated"
                                                inset
                                                :readonly="readonly || !worker.paySlipUpdateOption"
                                                :label="$t('worker.pay_active')"
                                                hide-details="auto"
                                            />
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                            </v-container>
                        </v-tab-item>
                        <!-- Rubriques -->
                        <v-tab-item eager v-if="worker.paySlipReadOption">
                            <v-container fluid v-if="!importPaySectionsLoading">
                                <w-fieldset
                                    :title="$t('module.pay_section')"
                                    show-add-action
                                    @add="importPaySections"
                                >
                                    <pay-section-selection
                                        v-if="worker.paySectionss"
                                        :initial-pay-section-selection="worker.paySectionss"
                                        :by-occupation="false"
                                        :pay-preview="viewAction || updateAction"
                                        :worker-id="$route.params.id"
                                        :readonly="readonly || !worker.paySlipUpdateOption"
                                        @updatePaySection="updatePaySection"
                                        show-import-pay-section
                                        :import-pay-sections-loading="importPaySectionsLoading"
                                        @importPaySections="importPaySections"
                                    ></pay-section-selection>
                                </w-fieldset>
                            </v-container>
                        </v-tab-item>
                        <!-- Arabic -->
                        <v-tab-item eager>
                            <v-container fluid>
                                <w-fieldset title="العربية">
                                    <v-row>
                                        <v-col cols="4">
                                            <w-label label="اللقب"/>
                                            <w-text-field
                                                v-model="worker.lastNameInArabic"
                                                :readonly="readonly"
                                            ></w-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label label="الاسم"/>
                                            <w-text-field
                                                v-model="worker.firstNameInArabic"
                                                :readonly="readonly"
                                            ></w-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label label="الجنسية"/>
                                            <w-text-field
                                                v-model="worker.nationaliteAr"
                                                :readonly="readonly"
                                            ></w-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label label="العنوان"/>
                                            <w-text-field
                                                v-model="worker.addressInArabic"
                                                :readonly="readonly"
                                            ></w-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <w-label label="مكان الازدياد"/>
                                            <w-text-field
                                                v-model="worker.birthPlaceInArabic"
                                                :readonly="readonly"
                                            ></w-text-field>
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                            </v-container>
                        </v-tab-item>
                        <!-- Champs Personaliser -->
                        <v-tab-item eager>
                            <v-container fluid flat v-if="!newOne">
                                <w-fieldset :title="$t('worker.personal_field')">
                                    <v-row dense>
                                        <v-col
                                            cols="6"
                                            v-for="(item, index) in worker.additionalFields"
                                            :key="index"
                                        >
                                            <w-text-field
                                                v-if="item.additionalField.field === 'TEXT_FIELD'"
                                                v-model="item.data"
                                                :label="item.additionalField.label"
                                            />
                                            <w-enum-select
                                                v-if="item.additionalField.field === 'SELECT'"
                                                v-model="item.data"
                                                :label="item.additionalField.label"
                                                :items="item.additionalField.data"
                                                item-value="name"
                                            />
                                            <w-date-picker
                                                v-if="item.additionalField.field === 'DATE_PICKER'"
                                                v-model="item.data"
                                                :label="item.additionalField.label"
                                                :readonly="readonly"
                                            />
                                            <w-month-picker
                                                v-if="item.additionalField.field === 'MONTH_PICKER'"
                                                v-model="item.data"
                                                :label="item.additionalField.label"
                                                :readonly="readonly"
                                            />
                                        </v-col>
                                    </v-row>
                                </w-fieldset>
                            </v-container>
                        </v-tab-item>
                        <!-- Congé et Soldes -->
                        <v-tab-item eager v-if="worker.balanceReadOption">
                            <v-container fluid v-if="!newOne">
                                <w-fieldset :title="$t('worker.vacation_and_balance')">
                                    <worker-balance
                                        :workerId="worker.id"
                                        :rootPath="rootPath"
                                        :update-action="updateAction"
                                        :delete-action="deleteAction"
                                        :view-action="viewAction"
                                    />
                                </w-fieldset>
                            </v-container>
                        </v-tab-item>
                        <!-- Contrats -->
                        <v-tab-item eager v-if="worker.contratReadOption">
                            <v-container fluid v-if="!newOne">
                                <w-fieldset :title="$t('worker.contrats')">
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-left">{{ $t("contrat.number") }}</th>
                                                <th class="text-left">{{ $t("module.contrat_template") }}</th>
                                                <th class="text-left">{{ $t("contrat.start") }}</th>
                                                <th class="text-left">{{ $t("contrat.end") }}</th>
                                                <th class="text-left">{{ $t("contrat.duration") }}</th>
                                                <th class="text-left">{{ $t("contrat.periodicity") }}</th>
                                                <th class="text-left">{{ $t("module.contrat_characteristic") }}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr
                                                v-for="contrat in worker.contrats"
                                                :key="contrat.number"
                                            >
                                                <td>{{ contrat.number }}</td>
                                                <td>{{ contrat.contratTemplateName }}</td>
                                                <td>{{ formatedDate(contrat.start) }}</td>
                                                <td>{{ formatedDate(contrat.end) }}</td>
                                                <td>{{ contrat.contratDuration }}</td>
                                                <td>{{ contrat.contratPeriodicity }}</td>
                                                <td>{{ contrat.contratCharacteristicName }}</td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </w-fieldset>
                            </v-container>
                        </v-tab-item>
                        <!-- WorkFlow -->
                        <v-tab-item eager>
                            <v-container fluid v-if="!newOne">
                                <w-fieldset :title="$t('worker.workflow')">
                                    <v-expansion-panels :value="0">
                                        <v-expansion-panel
                                            v-for="(item, index) in worker.validationWorkFlow"
                                            :key="`wkfl-${index}`"
                                        >
                                            <v-expansion-panel-header>
                                                <strong>
                                                    Module:
                                                    <span class="teal--text">
                                                        {{ $t(`module.${item.module.toLowerCase()}`) }}
                                                    </span>
                                                </strong>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <h4>{{ $t('module.validation_work_flow') }}: {{ item.validationWorkFlowName }}</h4>
                                                <br/>
                                                <v-simple-table dense>
                                                    <template v-slot:default>
                                                        <thead>
                                                        <tr>
                                                            <th class="text-left">{{ $t('common.state') }}</th>
                                                            <th class="text-left">{{ $t('common.validator') }}</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr
                                                            v-for="(step, index) in item.steps"
                                                            :key="`wstep-${index}`"
                                                        >
                                                            <td>{{ step.stepName }}</td>
                                                            <td>{{ step.validatorFullName }}</td>
                                                        </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </w-fieldset>
                            </v-container>
                        </v-tab-item>
                        <!-- Carrière -->
                        <v-tab-item eager>
                           <!-- <v-container fluid v-if="!newOne">
                                <w-fieldset :title="$t('worker.career')">
                                    <v-tabs color="teal">
                                        <v-tab
                                            v-for="(property, key) in worker.histories"
                                            :key="key"
                                        >
                                            <div v-if="key === 'base_salary'">{{ $t('worker.salary') }}</div>
                                            <div v-if="key === 'state'">{{ $t('data_select.WORKER_STATE') }}</div>
                                        </v-tab>
                                        <v-tab-item
                                            v-for="(property, key) in worker.histories"
                                            :key="key"
                                        >
                                            <v-container fluid>
                                                <v-simple-table dense>
                                                    <template v-slot:default>
                                                        <thead>
                                                        <tr>
                                                            <th>{{ $t('common.start') }}</th>
                                                            <th>{{ $t('common.end') }}</th>
                                                            <th></th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(v, index) in property" :key="index">
                                                            <td>{{ formatedDate(v.start) }}</td>
                                                            <td>
                                                                <div v-if="v.end">
                                                                    {{ formatedDate(v.end) }}
                                                                </div>
                                                                <div v-else>{{ $t('worker.until_now') }}</div>
                                                            </td>
                                                            <td>
                                                                <div v-if="key === 'base_salary'">
                                                                    {{ priceFormat(v.value) }}
                                                                </div>
                                                                <div v-else>
                                                                    {{ v.value }}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-container>
                                        </v-tab-item>
                                    </v-tabs>
                                </w-fieldset>
                            </v-container>-->
                        </v-tab-item>
                    </v-tabs>
                </v-card-text>
                
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                    <w-btn-add
                        :show="newOne"
                        :loading="loading"
                        :error="!allValidate"
                        @press="save"
                    />
                    <w-btn-update
                        :show="editOne"
                        :loading="loading"
                        :error="!allValidate"
                        @press="update"
                    />
                    <w-btn-delete
                        :show="deleteAction"
                        :loading="loading"
                        @press="overlay = true"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog
            transition="dialog-bottom-transition"
            v-model="childDialog"
            max-width="500"
            persistent
        >
            <v-card>
                <w-toolbar color="blue darken-2" :title="$t('worker.child')"/>
                <v-card-text>
                    <v-form ref="childForm" lazy-validation>
                        <v-container fluid>
                            <v-row>
                                <v-col cols="6">
                                    <w-label :label="$t('common.lastname')" required/>
                                    <w-text-field
                                        v-model="child.lastName"
                                        :rules="[mxRules.required]"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <w-label :label="$t('common.firstname')" required/>
                                    <w-text-field
                                        v-model="child.firstName"
                                        :rules="[mxRules.required]"
                                    />
                                </v-col>
                                
                                <v-col cols="6">
                                    <w-label :label="$t('common.birth_day')" required/>
                                    <w-date-picker
                                        v-model="child.birthDay"
                                        birth-day-picker
                                        :rules="[mxRules.required]"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <w-label :label="$t('common.sex')" required/>
                                    <w-enum-select
                                        v-model="child.sex"
                                        :items="sex"
                                        :rules="[mxRules.required]"
                                    />
                                </v-col>
                                
                                <v-col cols="6">
                                    <w-label :label="$t('common.schooled')" required/>
                                    <w-data-select-autocomplete
                                        v-model="child.schoolSituationId"
                                        type="WORKER_SCHOOL_SITUATION"
                                        :rules="[mxRules.required]"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <w-label :label="$t('common.school_level')"/>
                                    <w-text-field v-model="child.schoolLevel"/>
                                </v-col>
                                <v-col cols="6">
                                    <v-switch
                                        v-model="child.chronicDisease"
                                        :true-value="'1'"
                                        :false-value="'0'"
                                        :label="$t('worker.chronic_disease')"
                                        inset
                                        color="red"
                                        hide-details
                                    ></v-switch>
                                </v-col>
                                <v-col cols="6">
                                    <v-switch
                                        v-model="child.cnasRight"
                                        :true-value="'1'"
                                        :false-value="'0'"
                                        :label="$t('worker.cnas_law')"
                                        inset
                                        color="teal"
                                        hide-details
                                    ></v-switch>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="closeChildDialog"/>
                    <w-btn-add
                        :show="addChild"
                        @press="saveChild"
                    />
                    <w-btn-update
                        :show="!addChild"
                        @press="closeChildDialog"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <router-view/>
    </div>
</template>

<style lang="scss" scoped>
div.tabs [role="tab"] {
    justify-content: flex-start;
}
</style>